import { render, staticRenderFns } from "./projectsModal.vue?vue&type=template&id=fc0c0888&scoped=true"
import script from "./projectsModal.vue?vue&type=script&lang=js"
export * from "./projectsModal.vue?vue&type=script&lang=js"
import style0 from "./projectsModal.vue?vue&type=style&index=0&id=fc0c0888&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0c0888",
  null
  
)

export default component.exports